import React, { useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "react-axios";

import { postQuote } from "~/api/getQuotes";
import { validate } from "./AddQuoteValidationRules";
import useQuotesForm from "../useQuotesForm";
import { useUser } from "@dreamchimney/user-context";
import { LOCAL_STORE_JWT } from "~/utils/main";

const AddQuoteForm = ({ onComplete, onFailure }) => {
  const { state: userState, dispatch } = useUser();
  const [loading, setLoading] = useState(false);

  const initialFormValues = {};

  const postForm = async () => {
    setLoading(true);

    const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
    const payload = {
      jwt,
      user: userState.user.dir,
      ...inputs,
    };

    try {
      console.log("🚀 ~ file: AddQuoteForm.js ~ line 31 ~ postForm ~ payload", payload);
      await postQuote(axios, payload);
      setLoading(false);
      onComplete();
    } catch (err) {
      setLoading(false);
      onFailure();
    }
  };

  const { inputs, handleInputChange, handleSubmit, errors } = useQuotesForm(initialFormValues, postForm, validate);
  return (
    <Form className="quote-form quote-box-lite quote-add-form" noValidate onSubmit={(e) => handleSubmit(e)}>
      <div className="col-text-center">
        <p>Enter a great quote that you found online or just happened to overhear.</p>
      </div>

      <Form.Group>
        <Row className="quote-form-row">
          <Col xs={12} md={12} className="quote-form-row">
            <Col md={10} className={errors.quote ? "error" : ""}>
              <Form.Label>Quote:</Form.Label>
              <Form.Control
                disabled={loading}
                name="quote"
                onChange={handleInputChange}
                value={inputs.quote || ""}
                as="textarea"
                rows="3"
              />
              <Form.Text className="text-muted">Note: You dont need to enter the quote marks</Form.Text>
              {errors.quote && <span className="help error">{errors.quote}</span>}
            </Col>
          </Col>
        </Row>
        <Row className="quote-form-row">
          <Col xs={12} md={12}>
            <Col md={6} className={errors.quoted ? "error" : ""}>
              <Form.Label>Who Said It:</Form.Label>
              <Form.Control
                disabled={loading}
                name="quoted"
                onChange={handleInputChange}
                value={inputs.quoted || ""}
                type="text"
                autoComplete="off"
                required
              />
              <Form.Text className="text-muted">Enter the name of the person that said the quote</Form.Text>
              {errors.quoted && <span className="help error">{errors.quoted}</span>}
            </Col>
          </Col>
        </Row>
        <Row className="quote-form-row">
          <Col xs={12} md={12}>
            <Col md={8} className={errors.url ? "error" : ""}>
              <Form.Label>Source:</Form.Label>
              <Form.Control
                disabled={loading}
                name="url"
                onChange={handleInputChange}
                value={inputs.url || ""}
                type="text"
                autoComplete="off"
                placeholder="https://"
              />
              <Form.Text className="text-muted">Optional: Include the source url of the quote</Form.Text>
              {errors.url && <span className="help error">{errors.url}</span>}
            </Col>
          </Col>
        </Row>
        <Row className="quote-form-row">
          <Col md={12} style={{ textAlign: "center" }}>
            <Button disabled={loading} size="lg" variant="secondary" type="submit">
              Submit
            </Button>
            {/* <Button onClick={(e) => backButton(e)} disabled={loading} variant="cancel" type="cancel">
                Cancel
              </Button> */}
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );
};

export default AddQuoteForm;
